<template>
  <svg 
    xmlns="http://www.w3.org/2000/svg"
    :fill="fill || null"
    :height="height"
    :viewBox="viewBox" 
    :width="width"
    focusable="false"
    aria-hidden="true"
  >
    <slot />
  </svg>
</template>
<script src="./IconComponent.es"></script>
